import { useSelector, useDispatch } from 'react-redux'
import { quantitySet } from '../actions'
import { t } from '../utils/i18n'

const QuantityField = () => {
  const quantityRaw = useSelector((state) => state.quantityRaw)
  const dispatch = useDispatch()

  const handleQuantityChange = (e) => {
    dispatch(quantitySet(e.target.value))
  }

  return (
    <div className="velorbis-customizer-form-control">
      <label>{t('quantity')}</label>
      <input
        type="number"
        className="velorbis-customizer-input"
        value={quantityRaw}
        onChange={handleQuantityChange}
      />
    </div>
  )
}

export default QuantityField
